import { render } from "./Role_manage.vue?vue&type=template&id=2cd36d89"
import script from "./Role_manage.vue?vue&type=script&lang=js"
export * from "./Role_manage.vue?vue&type=script&lang=js"
script.render = render

export default script